import {
	CARD_CONTAINER_SELECTOR,
	DRAGGABLE_COLUMN_SELECTOR,
	DATA_ANNOUNCED_IGNORE_DND_TYPE,
	DATA_ANNOUNCED_COLUMN_HEADER,
	DATA_ANNOUNCED_CARD_HEADER,
} from '../../constants';

function findColumnHeader(el?: Element | null) {
	if (!el) return '';
	const announcedHeader = el.getAttribute(DATA_ANNOUNCED_COLUMN_HEADER);
	return announcedHeader || el.querySelector('h2 > *:first-child')?.innerHTML || '';
}

export const getDraggingCardStatus = (
	droppableId: string,
	draggingCardRef?: Element,
): {
	columnName: string;
	issueKey: string;
	totalCards: number;
	ignoreDndTypeInMessage: boolean;
} => {
	if (droppableId === 'board') {
		const parent = draggingCardRef?.parentElement;
		const siblings = parent?.querySelectorAll(`:scope > ${DRAGGABLE_COLUMN_SELECTOR}`);
		const totalCards = siblings?.length || 1;
		return {
			columnName: '',
			issueKey: findColumnHeader(draggingCardRef),
			totalCards,
			ignoreDndTypeInMessage: false,
		};
	}

	const column =
		document.querySelector<HTMLElement>(
			`[data-rbd-draggable-id="${droppableId}"]${DRAGGABLE_COLUMN_SELECTOR}`,
		) || document.querySelector(`[data-announced-id="${droppableId}"]`);

	const issueId = draggingCardRef?.getAttribute('id') ?? '';
	const header = draggingCardRef?.getAttribute(DATA_ANNOUNCED_CARD_HEADER);
	const idKey = issueId !== '' ? (/card-(.+)/.exec(issueId) ?? ['', ''])[1] : '';
	const issueKey = header || idKey;

	if (!column) return { columnName: '', issueKey, totalCards: 1, ignoreDndTypeInMessage: false };

	const ignoreDndTypeInMessage = column.hasAttribute(DATA_ANNOUNCED_IGNORE_DND_TYPE);
	const totalCards = column.querySelectorAll(CARD_CONTAINER_SELECTOR).length;
	const columnName = findColumnHeader(column);

	return { columnName, issueKey, totalCards, ignoreDndTypeInMessage };
};
